<template>
    <div class="pd-12 top-border-bottom">
        <a class="exch-breadcrumb-heading-sec" @click="$router.go(-1)">
            <img  src="@/assets/images/back.webp" alt="back" >
            <h5 class="text-capitalize">Back To Amount</h5>
        </a>
    </div>
    <div class="exch-deposit-wrapper">
        <div class="mr-row-sec">
            <div class="multiSteps-container multiSteps-withdraw">
                <div class="multiSteps-points">
                    <div class="points-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 11 10" fill="none" class="w-3 h-3"><path d="M4.31258 7.43734L1.97925 5.104L2.42716 4.65609L4.31258 6.5415L8.31258 2.5415L8.7605 2.98942L4.31258 7.43734Z" fill="#E7EAEF" stroke="#E7EAEF" stroke-width="0.8"></path></svg>
                    </div>
                    <div class="points-border"></div>
                    <div class="points-circle active">2</div>
                </div>
                <div class="multiSteps-name">
                    <div class="title-wrap">{{ $t('enter-amt', 'Enter amount') }}</div>
                    <div class="title-wrap active">{{ $t('select-account', 'Select Account') }}</div>
                </div>
            </div>
            <div class="exch-payment-step-content-wrapper">
                <div class="wallet-list-wrapper">
                    <div class="exch-deposit-amount-sec">
                        <div class="exch-upi-title">
                            <label class="sm-bd-font">{{ $t('choose-from-recent-accounts', 'Choose From Recent Accounts') }}</label>
                            <label class="sm-bd-font amount_inpt_filed">{{ $t('amount', 'Amount') }} : <span class="color-even">{{ amount }}</span></label>
                        </div>
                        <div class="account-data">
                            <div class="account-wrap" v-for="(item, index) in accountsList" :key="index">
                                <div class="account-item" :class="{ 'selected-card': selectedCardIndex === index, 'non-selected-card': selectedCardIndex !== index && selectedCardIndex !== null }" @click="getBankId(index, item)">
                                    <div class="recent-bank">
                                        <div class="slct_bank_container">
                                            <div class="bank-icon">
                                            <img :src="item?.icon ? item?.icon : require('@/assets/images/bank-img.svg')" alt="">
                                            </div>
                                        </div>
                                        <div class="bank-con slct_bank_details">
                                            <div>
                                                <label>Bank Name :- </label>
                                                <span class="slct_bank_list_name">{{ item.method_name ? item.method_name : item.payment_type_name }}</span>
                                            </div>
                                            <div>
                                                <label>Name :-</label>
                                                <span class="slct_bank_list_name">{{ item.account_holder_name }}</span>
                                            </div>
                                            <div v-if="item?.ifsc_code">
                                                <label>IFSC :-</label>
                                                <span class="slct_bank_list_name">{{ item?.ifsc_code }}</span>
                                            </div>
                                            <div v-if="item?.account_number">
                                                <label>Account Number :- </label>
                                                <span class="slct_bank_list_name">{{ item?.account_number }} </span>
                                            </div>
                                            <div v-if="item?.phone_number">
                                                <label>Phone Number :- </label>
                                                <span class="slct_bank_list_name">{{ item?.phone_number }}</span>
                                            </div>
                                            <div v-if="item?.upi_id">
                                                <label>UPI ID :- </label>
                                                <span class="slct_bank_list_name">{{ item?.upi_id }}</span>
                                            </div>
                                            <div v-if="item?.crypto_wallet_id">
                                                <label>Wallet ID :- </label>
                                                <span class="slct_bank_list_name">{{ item?.crypto_wallet_id }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="menu-dots12">
                                        <div class="btn-group dropstart">
                                            <button type="button" @click="selectedRemoveAcc = item; openDeleteAccModal()" class=" border-0 bg-transparent">
                                                <img src="@/assets/images/delete_icon.svg" alt="">
                                            </button>
                                            <!-- <ul class="dropdown-menu">
                                                <button @click="deleteServiceCall(item)" class="border-0 bg-transparent">
                                                    <div class="remove-sec">
                                                        <div class="remove-icon">
                                                            <img src="@/assets/images/remove-icon.svg" alt="">
                                                        </div>
                                                        <div class="remove-con">
                                                            <span>{{ $t('remove-account', 'Remove account') }}</span>
                                                        </div>
                                                    </div>
                                                </button>
                                            </ul> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <a @click="withdrawAmountServiceCall()" class="green-theme-btn mb-2 w-100">
                            {{ $t('withdraw', 'Withdraw') }}
                        </a>
                        <!-- <p  class="no_bank_added" >No bank accounts added.</p> -->
                        <div class="exch-upi-title">
                            <label class="sm-bd-font">{{ $t('add-new-account', 'Add New Account') }}</label>
                            <!-- <div class="forgot-check-box-section">
                                <div class="forgot" v-if="$siteSettings?.data?.business_type == 2"> 
                                    <a href="javascript:void(0)" class="blue-link" @click="forgetWithdrawModal()">{{$t('forgot-withdraw-password','Forgot Withdraw Password')}}?</a>
                                </div>
                            </div> -->
                        </div>
                        <ul class="exch-top-account-menu-box-wrapper exch-add-bank-list-sec">
                            <li v-for="(item, index) in paymentMethodList" :key="index">
                                <a @click="selectAccount(item)">
                                    <div class="bank_list_wrapper_main">
                                        <div class="bank_list_icons12">
                                            <img :src="item.icon ? item.icon : require('@/assets/images/bank-img.svg')" alt="bank-img">
                                        </div>
                                        <div class="bank_name_list">
                                            <span class="sm-bd-font">{{ item?.method_name }}</span>
                                        </div>
                                    </div>
                                    <div>
                                        <span class="exch-list-right-arrow">
                                        <span class="fa-solid fa-chevron-right"></span>
                                        </span>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Success modal -->
    <div class="modal fade exch-success-msg-modal" id="exch-success-msg-modalToggle" aria-hidden="true" aria-labelledby="exch-success-msg-modalToggleLabel" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content transparent-modal-content">
                <div class="e-p-content-bc1">
                    <div class="e-p-body-bc" style="overflow-y: auto;">
                        <div class="login-page-abc">
                            <div class="login-page">
                                <div class="login-box">
                                    <div class="login-card">
                                        <div class="login-card-header exch-modal-popup-header-section">
                                            <div class="login-text">
                                                <p>{{ $t('withdraw', 'Withdraw') }}</p>
                                            </div>
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"> <i class="fa fa-close"></i> </button>
                                        </div>
                                        <div class="exch-cashout-body-center exch-success-msg-div">
                                            <div class="exch-success-check-div"> <span class="fa fa-check"></span> </div>
                                            <h3>{{ $t('success', 'Success') }}</h3>
                                            <p>{{ $t('acc-add-success', 'Account added successfully') }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
       
    <!-- delete acc modal pop up -->
    <div class="delete_account_modal">
        <div class="modal fade worli-Bets-Modal" id="delAccountModal" ref="deleteModalRef" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <DeleteAccount v-if="selectedRemoveAcc" @yes-click="removeAccountHere()" @close="closeModal()" :item="selectedRemoveAcc" />
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { getUserAccounts } from '../services/withdrawDetails';
import { withdrawWalletAmount, removeAccount  } from '../services/withdrawDetails';
import DeleteAccount from '../components/DeleteModal.vue';
export default {
    name: "WithdrawSelectAccount",
    inject: ['walletConfig'],
    data() {
        return {
            amount: null,
            loading: false,
            accountsList: [],
            selectBankId: null,
            onlyBankStatus: false,
            selectedCardIndex: null,
            paymentMethodList: null,
            selectedRemoveAcc: null,
            is_withdrawal_password_set:false,
        }
    },
    mounted() {
        this.amount = this.$store.getters.withdrawalAmount;
        this.getUserAccounts();
        // this.getPaymentMethods(this.onlyBank)
        // this.userAccountDetails();
    },
    components: {
        DeleteAccount,
    },
    methods: {
        getBankId(index, bankId) {
            this.selectUserAccount(bankId);
            this.selectedCardIndex = index;
            this.selectBankId = bankId;
        },
        fetchOnlyBankStatus(reconnectTry = 0) {
			this.loading = true;
            this.$apiCall('get', 'ONLY_BANK_STATUS', null, 'wallet', null).then(response => {
				this.loading = false;
				if (response) {
					if (response.status == 200) {
						if (response?.data?.status == 0) {
							this.$errorToast(response?.data?.debug[0]);
						}
						else {
							this.getPaymentMethods(response?.data?.data?.only_banks)
						}
					}
				}
			}).catch(error => {
                if(reconnectTry < 3 && !error) {
                    this.fetchOnlyBankStatus(reconnectTry + 1);
                }
                else {
                    this.loading = false;
                    if (error) {
                        this.$errorToast(error[0]);
                    }
                }
			});
		},
        async getUserAccounts() {
            let response = await getUserAccounts(this.walletConfig?.payment_method)
            this.accountsList = response.userAccounts;
            this.withdrawAccountType = response.withdrawAccountType;
            this.paymentMethodList = response.paymentMethods;
            if(this.accountsList && this.accountsList.length > 0) {
                this.selectUserAccount (this.accountsList?.[0]);
            }
        },
        selectUserAccount(account){
            this.selectedCardIndex = 0; // Set to the first account index
            this.accountId = account.client_account_id;
            // this.withdrawAccountType = {
            //     type : account.bank_name ? account.bank_name : account.payment_type_name,
            //     holderName: account.account_holder_name
            // };
        },
        selectAccount(item) {
            this.$store.dispatch('setSelectedAccountData', item);
            this.$router.push({ name: 'withdraw-selected-account-detail' });
        },
        async withdrawAmountServiceCall(){
            console.log("this.accountsList", this.accountsList);
            if (this.accountsList.length === 0) {
                this.$errorToast('Add Account to Withdraw');
                return false;
            }
            if (this.amount > this.$auth?.user?.balance) {
                this.$errorToast('Insufficient balance.');
                return false;
            }
            this.$store.dispatch('setGlobalLoader', true);
            let response = await withdrawWalletAmount(this.amount, this.accountId)
            if(!response?.error){
                this.$router.push({ name: 'Home' });
            }
        },
        openDeleteAccModal(){
            this.$nextTick(() => {
                this.$helper.openModal('#delAccountModal')
			});
        },
        removeAccountHere() {
            this.closeModal();
			let index = this.accountsList.indexOf(this.selectedRemoveAcc);
			this.accountsList.splice(index, 1);
            this.getUserAccounts();
		},
		closeModal() {
            this.selectedRemoveAcc = null;
            this.$helper.closeModal('delAccountModal')
		},
    }
}
</script>